import { DotsSixVertical } from '@phosphor-icons/react';

export default DotsSixVertical;
